import { render } from "./ProductsSection.vue?vue&type=template&id=5beaf1da&scoped=true"
import script from "./ProductsSection.vue?vue&type=script&lang=js"
export * from "./ProductsSection.vue?vue&type=script&lang=js"

import "./ProductsSection.vue?vue&type=style&index=0&id=5beaf1da&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5beaf1da"]])

export default __exports__